:host {
  --border-radius: calc(var(--spacer) / 2);
  --input-height: calc(4 * var(--spacer));
  --input-btn-width: calc(3 * var(--spacer));
  --input-btn-height: calc(3 * var(--spacer));
  --divider-height: 20px;
  --transparent-border: 1px solid transparent;
}

.phone-input-wrapper {
  display: flex;
  font-size: var(--body-size);
  align-items: center;
  position: relative;
  transition: all 0.2s ease;
  border-radius: var(--border-radius);
  border: 1px solid var(--gz-phone-input-border-color);
  height: var(--input-height);
  background-color: var(--white-layout-301-level-0-elevation);
  font-family: var(--font-family-secondary);
  width: fit-content;

  &.error {
    border-color: var(--red-layout-300-primary);

    gz-input,
    gz-single-select-phone-code {
      &:hover,
      &:focus,
      &:active {
        border-color: transparent;
      }
    }
  }

  .divider {
    height: var(--divider-height);
    width: 1px;
    background: var(--chart-100-pressed);
    margin: 0 1px;
    z-index: 997;
  }
}

.label {
  margin-top: 7px;
  width: 148px;
}

gz-input {
  border: var(--transparent-border);
  margin-left: -2px;
  border-radius: var(--border-radius);
  width: calc(100% + 10px);
  margin-right: -1px;
  border-right-color: var(--gz-phone-input-border-color);

  &::part(input) {
    border: none;
    height: 30px;
  }

  &:hover {
    border-color: var(--main-titles-inputs-600);
  }

  &:focus {
    border-color: var(--blue-layout-301-active);
  }

  &:active {
    border-color: var(--blue-layout-301-active);
  }
}

gz-single-select-phone-code {
  width: calc(var(--spacer) * 10);
  border: var(--transparent-border);
  height: calc(4 * var(--spacer));
  border-radius: var(--border-radius);
  margin-right: -2px;
  margin-left: -1px;
  border-left-color: var(--gz-phone-input-border-color);

  &::part(list) {
    width: calc(30 * var(--spacer));
  }
}

.error-text {
  font-size: var(--body-size);
  color: var(--red-layout-300-primary);
  padding-left: calc(1.5 * var(--spacer));
  font-family: var(--font-family-secondary);
}

.error-tooltip {
  margin-top: 6px;
}

gz-form-field {
  height: inherit;
}

gz-single-select-phone-code {
  &:hover {
    border-color: var(--main-titles-inputs-600);
  }

  &:active,
  &:focus {
    border-color: var(--blue-layout-301-active);
  }
}

gz-form-field,
gz-input,
gz-single-select-phone-code {
  z-index: 0;

  &:hover,
  &:focus,
  &:active {
    position: relative;
    z-index: 999;
  }
}

:host([open]) {
  gz-single-select-phone-code {
    border-color: var(--blue-layout-301-active);
    z-index: 1000;
  }
}

.component-wrapper {
  width: fit-content;
  display: flex;
}

gz-text {
  color: var(--main-titles-inputs-600);
}

:host([data-invalid]) {
  .phone-input-wrapper {
    border-color: var(--red-layout-300-primary) !important;

    gz-input,
    gz-single-select-phone-code {
      &:hover,
      &:focus,
      &:active {
        border-color: transparent;
      }
    }
  }

  gz-single-select-phone-code {
    border-left-color: var(--red-layout-300-primary) !important;
  }

  gz-input {
    border-right-color: var(--red-layout-300-primary) !important;
  }
}

:host([open][data-invalid]) {
  gz-single-select-phone-code {
    border-color: var(--red-layout-300-primary);
    border-right-color: transparent;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
}

:host([readonly]) {
  pointer-events: none;

  .phone-input-wrapper {
    background-color: var(--chart-050-hover);
    border-color: transparent;
  }

  gz-input::part(input) {
    background-color: transparent;
  }

  gz-single-select-phone-code {
    border-left-color: transparent;
    --error-text: var(--body-text-arrows-400);
  }

  gz-input {
    border-right-color: transparent;
    pointer-events: none;
    opacity: 1;
  }
}
